import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../auth/css/forgotPassword.css";
import SolarSquare from "../../assets/img/logo.svg";
import ApiUrl from "../../common/apiUrl";
import Loader from "../common/loader";


const ForgotPassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const { token } = useParams();
  const [isInvalidToken, setIsInvalidToken] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loader, setLoader] = useState(false);


  function handleChange(e) {
    setError('');
    const { name, value } = e.target;
    if (name === "new-password") {
      setNewPassword(value);
    } else if (name === "password") {
      setOldPassword(value);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!oldPassword || !newPassword) {
      setError('Both passwords are required');
      return;
    }

    if (oldPassword !== newPassword) {
      setError('Passwords do not match');
      return;
    }

    await updatePassword();

    // setOldPassword('');
    // setNewPassword('');
    setError('');
  }

  async function validateToken(token) {
    const myHeaders = new Headers();
    myHeaders.append("X-Tenant-Id", process.env.REACT_APP_X_TENANT_ID);
    myHeaders.append("x-auth-token", token);
    setLoader(true);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(ApiUrl.FORGOT_PASSWORD_ENDPOINT_VALIDATE, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (result) {
          let parsedResult = JSON.parse(result);
          if (parsedResult?.message === "success") {
            setIsInvalidToken(false);
          } else {
            setIsInvalidToken(true);
          }
        }
      }).catch((error) => console.error("Error in validateToken", error)).finally(() => {
        setLoader(false);
      })



  }

  async function updatePassword() {
    setSubmitted(true);
    const myHeaders = new Headers();
    myHeaders.append("X-Tenant-Id", process.env.REACT_APP_X_TENANT_ID);
    myHeaders.append("x-auth-token", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "password": newPassword
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(ApiUrl.FORGOT_PASSWORD_ENDPOINT_UPDATE, requestOptions)
      .then((response) =>
        response.text()
      )
      .then((result) => {
        if (result) {
          result = JSON.parse(result);

          if (result?.status) {
            setIsUpdated(true);
          } else {
            setIsUpdated(false);
            setError('Error in updating password');
          }
        }
      }
      )
      .catch((error) => console.error("Error in updatePassword", error)).finally(() => {
        setSubmitted(false);
      })

  }


  useEffect(() => {
    if (token) {
      validateToken(token);
    }
  }, [token])


  return (
    <div className="login-container">
      {loader ? <Loader /> : (
        <div className="login-card">
          {
            isUpdated ? (
              <div className="sign-in-success">
                <h2 className="login-title sign-in-success-h2">Password updated successfully</h2>
                <p className="sign-in-success-p">Your password has been updated successfully. Please login with your new password</p>
              </div>
            ) : (
              isInvalidToken ? (
                <div className="sign-in-success">
                  <h2 className="login-title sign-in-success-h2">Invalid link</h2>
                  <p className="sign-in-success-p">The link you have entered is expired. Please try again with a valid link</p>
                </div>
              ) : (
                <>
                  <div className="logo-container">
                    <div className="logo">
                      <img src={SolarSquare} alt="solar-sqaure" className="img-logo" />
                    </div>
                  </div>

                  <h2 className="login-title">Create New Password</h2>
                  <p className="login-subtitle">To create the new password you need the following details</p>

                  {error && <p className="error-message" style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label>New password</label>
                      <input
                        type="text"
                        name="new-password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={handleChange}
                        className="input-field"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Confirm password</label>
                      <input
                        type="text"
                        name="password"
                        placeholder="Confirm password"
                        value={oldPassword}
                        onChange={handleChange}
                        className="input-field"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <button type="submit" className="submit-button" disabled={submitted}>
                        {
                          submitted ? "Please wait..." : "Submit"
                        }
                      </button>
                    </div>
                  </form>
                </>
              )
            )
          }
        </div>
      )}

    </div>
  );
};

export default ForgotPassword;